
- use Object styles instead of styled components until we can fix the inject

# Late Night

I finally went to bed around 11:30pm last night. Woke back up at 3:30am with this hyper productivity mindset. Back to my computer and looking at the rest of the NPM packages I still need to work through for `cdbattaglia-web` and decided to choose the `@down-the-whole/intro`.

This package is very unique because it's just a frontend but with some fanciness in the form of React/TypeScript all in Vite which is the VitePress system of bundling SSR but not in realtime. I could even use this for SSR if I really wanted to...?

Vite is marvelous because it operates at lightspeed. Think of it like Uber Fusion.js meets Vue and others!

# `.gitignore` File Copy

This would make a great binary that I can make in Rust.

```
curl https://raw.githubusercontent.com/github/gitignore/master/Node.gitignore > .gitignore
```

# PIM -> Magento -> Mirakl

- offers
  - inventory
  - price
- products
  - name
  - SKU
  - etc

# Twitter Opinions

> "Still find it hard to voice my opinion on twitter. I am like oh i could reply here. Then I am like no that’s stupid."

> "My rule of thumb is pretend like the whole world is listening"

> "Privacy doesn't exist online"
